"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const KnowledgeBase_1 = __importDefault(require("./KnowledgeBase"));
class Knowledge extends KnowledgeBase_1.default {
}
module.exports = Knowledge;
